import { deClientPortalDashboardHistoryChart } from './Dashboard/DashboardHistoryChart'
import { deClientPortalDashboardPage } from './Dashboard/Dashboard'
import { deClientPortalNewsFromEinwertWidget } from './Dashboard/NewsFromEinwertWidget'

export const deClientPortalDashboardPages = {
    dashboard: {
        dashboard: deClientPortalDashboardPage,
        dashboardHistoryChart: deClientPortalDashboardHistoryChart,
        newsFromEinwertWidget: deClientPortalNewsFromEinwertWidget,
    },
}
